import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import "./Dashboard.css";
import { useAuth } from "../context/AuthContext";
import GuesthouseAdminPanel from "./GuesthouseContent/GuesthouseAdminPanel";

const LEGACY_PORTAL_BASE = (process.env.REACT_APP_LEGACY_PORTAL_BASE || "http://127.0.0.1").replace(/\/$/, "");

export default function Dashboard() 
{
  const navigate = useNavigate();
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const localUser = (() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();

  const moduleId = parseInt(localUser?.moduleId || user?.moduleId, 10);
  const empId = parseInt(localUser?.id || user?.id, 10);
  const deptId = parseInt(localUser?.deptid || user?.deptid, 10);
  const isModuleTwo = moduleId === 2;
  const isModuleThree = moduleId === 3;
  const isFacultyModule = moduleId === 13;
  const isModuleSeven = moduleId === 7;
  const isModuleFifteen = moduleId === 15;
  const showAttendanceButtons = [26, 75, 99, 102, 109, 110, 192, 210, 211, 214].includes(deptId);
  const backOfficeAttendanceDepts = [26, 75, 99, 109, 110, 192, 210, 211, 214].includes(deptId);
  const isDeputyRegistrarEstate = deptId === 108;
  const isGuesthouseAdminModule = moduleId === 10;

  const legacyLink = (target) => `${LEGACY_PORTAL_BASE}/${target}`;

  const moduleTwoButtons = [
    ...(backOfficeAttendanceDepts
      ? [
          {
            title: "Attendance",
            href: legacyLink("Attendance/RptTeaMonAttTimeLeave.php"),
            external: true,
            colorClass: "emp-btn-blue"
          }
        ]
      : []),
    ...(backOfficeAttendanceDepts
      ? [
          {
            title: "Pending Leave",
            href: legacyLink("LeaveMgmt/FormPendingLeaves.php"),
            external: true,
            colorClass: "emp-btn-pink"
          }
        ]
      : []),
    ...(isDeputyRegistrarEstate
      ? [
          {
            title: "CheckIn-CheckOut",
            href: legacyLink("RptLogBookRecord.php"),
            external: true,
            colorClass: "emp-btn-pink"
          }
        ]
      : []),
  ];

  useEffect(() => 
  {
    if (!empId || !moduleId) {
      setUnreadCount(0);
      return;
    }

    fetch(`/api/portal/mail-unread-count?empid=${encodeURIComponent(empId)}&moduleid=${encodeURIComponent(moduleId)}`)
      .then(res => res.json())
      .then(data => setUnreadCount(data.count || 0))
      .catch(() => {});
  }, [empId, moduleId]);

  useEffect(() => {
    if ([11, 22, 23, 27, 28].includes(moduleId)) {
      navigate("/guesthouse/room-logbook", { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  if (isGuesthouseAdminModule) {
    return (
      <section className="emp-panel-wrap">
        <GuesthouseAdminPanel onNavigate={(target) => navigate(target)} />
      </section>
    );
  }

  if ([1, 3, 7, 13, 16, 19].includes(moduleId)) return <Navigate to="/profile" replace />;
  if (moduleId === 9) return <Navigate to="/resolver-complaint-list" replace />;

  const actionButtons = isModuleTwo
    ? moduleTwoButtons
    : isModuleSeven
    ? [
        {
          title: "Profile",
          route: "/profile",
          colorClass: "emp-btn-blue"
        },
        ...(showAttendanceButtons
          ? [
              {
                title: "Mark Attendance",
                href: `${LEGACY_PORTAL_BASE}/indexBio.php`,
                external: true,
                colorClass: "emp-btn-pink"
              },
              {
                title: "View Attendance",
                href: `${LEGACY_PORTAL_BASE}/Attendance/RptPersonalStaffMonAtt.php`,
                external: true,
                colorClass: "emp-btn-emerald"
              }
            ]
          : []),
        {
          title: "Leave Details",
          route: "/LeaveDetails",
          colorClass: "emp-btn-green"
        },
        {
          title: "Official Complaints",
          route: "/official-complaints",
          colorClass: "emp-btn-purple"
        },
        {
          title: "Seniority List",
          route: "/seniority-list",
          colorClass: "emp-btn-indigo"
        },
        {
          title: "Personal Achievements",
          href: `${LEGACY_PORTAL_BASE}/Achievements/RptViewEmpAchievements.php`,
          external: true,
          colorClass: "emp-btn-blue"
        },
        {
          title: "Achievements (Departmental)",
          href: `${LEGACY_PORTAL_BASE}/Achievements/NewDeptAchievement.php`,
          external: true,
          colorClass: "emp-btn-pink"
        },
        {
          title: "Events/Activities (Departmental)",
          href: `${LEGACY_PORTAL_BASE}/Events/NewDeptEvent.php`,
          external: true,
          colorClass: "emp-btn-green"
        },
        {
          title: "Gallery (Departmental)",
          href: `${LEGACY_PORTAL_BASE}/Gallery/NewGallery.php`,
          external: true,
          colorClass: "emp-btn-emerald"
        },
        {
          title: "Generate QR",
          href: `${LEGACY_PORTAL_BASE}/FormQRCode.php`,
          external: true,
          colorClass: "emp-btn-purple"
        },
        {
          title: "Mail Box",
          href: `${LEGACY_PORTAL_BASE}/Mail/SendMessage.php`,
          external: true,
          colorClass: "emp-btn-slate",
          badgeCount: unreadCount
        }
      ]
    : isModuleThree
    ? [
        {
          title: "Profile",
          route: "/profile",
          colorClass: "emp-btn-blue"
        },
        {
          title: "Leave Details",
          route: "/LeaveDetails",
          colorClass: "emp-btn-green"
        },
        {
          title: "Official Complaints",
          route: "/official-complaints",
          colorClass: "emp-btn-purple"
        },
        {
          title: "Seniority List",
          route: "/seniority-list",
          colorClass: "emp-btn-indigo"
        },
        {
          title: "Personal Achievements",
          href: `${LEGACY_PORTAL_BASE}/Achievements/RptViewEmpAchievements.php`,
          external: true,
          colorClass: "emp-btn-blue"
        },
        {
          title: "Achievements (Departmental)",
          href: `${LEGACY_PORTAL_BASE}/Achievements/NewDeptAchievement.php`,
          external: true,
          colorClass: "emp-btn-pink"
        },
        {
          title: "Events/Activities (Departmental)",
          href: `${LEGACY_PORTAL_BASE}/Events/NewDeptEvent.php`,
          external: true,
          colorClass: "emp-btn-green"
        },
        {
          title: "Gallery (Departmental)",
          href: `${LEGACY_PORTAL_BASE}/Gallery/NewGallery.php`,
          external: true,
          colorClass: "emp-btn-emerald"
        },
        {
          title: "Generate QR",
          href: `${LEGACY_PORTAL_BASE}/FormQRCode.php`,
          external: true,
          colorClass: "emp-btn-purple"
        },
        {
          title: "Mail Box",
          href: `${LEGACY_PORTAL_BASE}/Mail/SendMessage.php`,
          external: true,
          colorClass: "emp-btn-slate",
          badgeCount: unreadCount
        },
        {
          title: "DAK Box",
          href: `${LEGACY_PORTAL_BASE}/DAK/SendDAK.php`,
          external: true,
          colorClass: "emp-btn-indigo",
          badgeCount: unreadCount
        }
      ]
    : isFacultyModule
    ? [
        {
          title: "Profile",
          route: "/profile",
          colorClass: "emp-btn-blue"
        },
        {
          title: "Leave Details",
          route: "/LeaveDetails",
          colorClass: "emp-btn-green"
        },
        {
          title: "Residential Complaints",
          route: "/residential-complaints",
          colorClass: "emp-btn-pink"
        },
        {
          title: "Official Complaints",
          route: "/official-complaints",
          colorClass: "emp-btn-emerald"
        },
        {
          title: "Guest House (Personal)",
          route: "/guesthouse/booking-status",
          colorClass: "emp-btn-purple"
        }
      ]
    : isModuleFifteen
    ? []
    : moduleId === 21
    ? []
    : moduleId === 17
    ? []
    : [11, 22, 23, 27, 28].includes(moduleId)
    ? []
    : moduleId === 5
    ? []
    : moduleId === 4
    ? []
    : [
        {
          title: "Profile",
          route: "/profile",
          colorClass: "emp-btn-blue"
        },
        {
          title: "Leave Details",
          route: "/LeaveDetails",
          colorClass: "emp-btn-green"
        },
        {
          title: "Holiday List",
          route: "/holidays",
          colorClass: "emp-btn-pink"
        },
        {
          title: "Directory",
          route: "/directory",
          colorClass: "emp-btn-emerald"
        },
        {
          title: "Change Password",
          route: "/change-password",
          colorClass: "emp-btn-purple"
        },
        {
          title: "Switch Roles",
          route: "/switch-role",
          colorClass: "emp-btn-indigo"
        },
        {
          title: "Logout",
          route: "/logout",
          colorClass: "emp-btn-slate"
        }
      ];

  if (actionButtons.length === 0) return null;

  return (
    <section className="emp-panel-wrap">
      <div className="emp-admin-btn-wrap">
        {actionButtons.map((item, idx) => (
          <button
            key={item.title}
            type="button"
            className={`emp-admin-btn ${item.colorClass} ${idx === 0 ? "emp-admin-btn-active" : ""}`}
            onClick={() => {
              if (item.external && item.href) {
                window.location.href = item.href;
                return;
              }
              if (item.route) {
                navigate(item.route);
              }
            }}
          >
            <span>{item.title}</span>
            {item.title === "Profile" && unreadCount > 0 ? <span className="emp-badge-inline">({unreadCount})</span> : null}
            {Number(item.badgeCount) > 0 ? <span className="emp-badge-inline">({item.badgeCount})</span> : null}
          </button>
        ))}
      </div>
    </section>
  );
}
